<template>
    <vx-card title="Редактировать набор" id="loader">
        <div class="vx-row mb-5">
            <div class="vx-col w-2/3">
                <div class="mt-1">
                    <label class="vs-input--label required"> Источник </label>
                    <v-select
                        :options="dicts.modelSources"
                        placeholder="Выберите источник"
                        label="name"
                        class="w-full"
                        v-model="item.modelSourceId"
                        v-bind:class="{ 'v-select-error': !!errors.modelSourceId }"
                        :reduce="(a) => a.id"
                    ></v-select>
                    <div v-if="errors.modelSourceId"
                        class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
                        style="height: 19px"
                    >
                        <span class="span-text-validation">
                            {{ errors.modelSourceId }}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="vx-row mb-5">
            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <vs-input
                        v-model="item.setModelName"
                        :danger="!!errors.setModelName"
                        :danger-text="errors.setModelName"
                        autocomplete="off"
                        label="Наименование набора"
                        class="mt-1 w-full required"
                    />
                </div>
            </div>

            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <vs-input
                        v-model="item.trafficPercent"
                        :danger="!!errors.trafficPercent"
                        :danger-text="errors.trafficPercent"
                        autocomplete="off"
                        type="number"
                        min="0"
                        max="100"
                        label="% траффика"
                        class="mt-1 w-full required"
                    />
                </div>
            </div>
        </div>

        <div class="vx-row mb-5">
            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <label class="vs-input--label required"> Модель base </label>
                    <v-select
                        :options="dicts.modelsBase"
                        placeholder="Выберите base модель"
                        label="name"
                        class="w-full"
                        v-model="item.modelBaseId"
                        v-bind:class="{ 'v-select-error': !!errors.modelBaseId }"
                        @input="onChangeModel(item.modelBaseId, 1)"
                        :reduce="(a) => a.id"
                    ></v-select>
                    <div v-if="errors.modelBaseId"
                        class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
                        style="height: 19px"
                    >
                        <span class="span-text-validation">
                            {{ errors.modelBaseId }}
                        </span>
                    </div>
                </div>
            </div>

            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <label class="vs-input--label required"> Модель base_cid </label>
                    <v-select
                        :options="dicts.modelsBaseCid"
                        placeholder="Выберите base_cid модель"
                        label="name"
                        class="w-full"
                        v-model="item.modelBaseCidId"
                        v-bind:class="{ 'v-select-error': !!errors.modelBaseCidId }"
                        @input="onChangeModel(item.modelBaseCidId, 2)"
                        :reduce="(a) => a.id"
                    ></v-select>
                    <div v-if="errors.modelBaseCidId"
                        class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
                        style="height: 19px"
                    >
                        <span class="span-text-validation">
                            {{ errors.modelBaseCidId }}
                        </span>
                    </div>
                </div>
            </div>

            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <label class="vs-input--label required"> Модель complete </label>
                    <v-select
                        :options="dicts.modelsComplete"
                        placeholder="Выберите complete модель"
                        label="name"
                        class="w-full"
                        v-model="item.modelCompleteId"
                        @input="onChangeModel(item.modelCompleteId, 3)"
                        v-bind:class="{ 'v-select-error': !!errors.modelCompleteId }"
                        :reduce="(a) => a.id"
                    ></v-select>
                    <div v-if="errors.modelCompleteId"
                        class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
                        style="height: 19px"
                    >
                        <span class="span-text-validation">
                            {{ errors.modelCompleteId }}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="vx-row mb-5">
            <div class="vx-col w-1/3">
                <div class="mt-1 p-5">
                    <h6 v-if="item.modelBaseFeatures && item.modelBaseFeatures.length > 0">Фичи:</h6>
                    <ul>
                        <li v-for="feature in item.modelBaseFeatures" class="mt-3">
                            {{ feature.featureName }}
                        </li>
                    </ul>
                </div>
            </div>

            <div class="vx-col w-1/3">
                <div class="mt-1 p-5">
                    <h6 v-if="item.modelBaseCidFeatures && item.modelBaseCidFeatures.length > 0">Фичи:</h6>
                    <ul>
                        <li v-for="feature in item.modelBaseCidFeatures" class="mt-3">
                            {{ feature.featureName }}
                        </li>
                    </ul>
                </div>
            </div>

            <div class="vx-col w-1/3">
                <div class="mt-1 p-5">
                    <h6 v-if="item.modelCompleteFeatures && item.modelCompleteFeatures.length > 0">Фичи:</h6>
                    <ul>
                        <li v-for="feature in item.modelCompleteFeatures" class="mt-3">
                            {{ feature.featureName }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="vx-row">
            <div class="vx-col w-full">
                <vs-button class="mt-5 mr-2" color="success" @click="save()" type="filled"> Сохранить </vs-button>
                <vs-button class="mt-5 mr-2" color="primary" @click="cancelEdit()" type="filled"> Отмена </vs-button>
                <!-- <vs-button class="mt-5" color="warning" @click="validate()" type="filled"> Проверить </vs-button> -->
            </div>
        </div>
    </vx-card>
</template>


<script>
import axios from 'axios';
import vSelect from 'vue-select';
import DatePicker from 'vue2-datepicker';

import CPA_ACC_TYPES from 'config/cpaAccTypes';

export default {
    name: 'cpa-push-model-source-set-edit',
    props: ['id'],
    data() {
        return {
            item: {
                modelSourceId: '',
                modelBaseId: 0,
                modelBaseCidId: 0,
                modelCompleteId: 0,
                trafficPercent: 0,
                setModelName: '',
                modelBaseFeatures:[],
                modelBaseCidFeatures: [],
                modelCompleteFeatures: []
            },
            form: {},
            dicts: {
                modelSources: [],
                models: [],
                modelsBase: [],
                modelsBaseCid: [],
                modelsComplete: [],
            },
            errors: {
                modelSourceId: '',
                modelBaseId: '',
                modelBaseCidId: '',
                modelCompleteId: '',
                trafficPercent: '',
                setModelName: ''
            }
        };
    },
    components: {
        'v-select': vSelect,
        'date-picker': DatePicker
    },
    methods: {
        loadData() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.axios
                .all([
                    this.axios.get('cpa-push-model-source-set/' + this.id),
                    this.axios.get('cpa-push-model-source-set/dicts')
                ])
                .then(
                    axios.spread((item, dicts) => {
                        this.$vs.loading.close('#loader > .con-vs-loading');
                        this.item = item.data;

                        this.setDictionaries(dicts);
                        
                        this.onChangeModel(item.data.modelBaseId);
                        this.onChangeModel(item.data.modelBaseCidId);
                        this.onChangeModel(item.data.modelCompleteId);
                    })
                )
                .catch((err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки набора моделей.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },

        setDictionaries(dicts) {
            if (dicts.data.modelSources) {
                for (let modelSourceProp in dicts.data.modelSources) {
                    this.dicts.modelSources.push({
                        id: dicts.data.modelSources[modelSourceProp].id,
                        name: dicts.data.modelSources[modelSourceProp].sourceName
                            + ' (распределение трафика:' + dicts.data.modelSources[modelSourceProp].lbTypeName + ')',
                    });
                }
            }

            if (dicts.data.models) {
                this.dicts.models = dicts.data.models;
                for (let modelProp in dicts.data.models) {
                    const model = {
                        id: dicts.data.models[modelProp].id,
                        name: dicts.data.models[modelProp].modelName
                            + ' (' + dicts.data.models[modelProp].modelTypeName 
                            + ', ' + dicts.data.models[modelProp].featureEncodingName + ')',
                        type: dicts.data.models[modelProp].modelAccType
                    };

                    switch(model.type) {
                        case CPA_ACC_TYPES.BASE:
                            this.dicts.modelsBase.push(model);
                            break;
                        case CPA_ACC_TYPES.BASE_CID:
                            this.dicts.modelsBaseCid.push(model);
                            break;
                        case CPA_ACC_TYPES.COMPLETE:
                            this.dicts.modelsComplete.push(model);
                            break;
                    }
                }
            }
        },

        save() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            const params = Object.assign({}, this.item, { 
                id: this.id
            });

            this.$axios({
                method: 'PUT',
                url: 'cpa-push-model-source-set/' + this.id,
                params: params,
                errors: this.errors,
                success: () => {
                    this.$vs.loading.close("#loader > .con-vs-loading");
                    this.$vs.notify({
                        title: "Успешно изменена",
                        text: "Набор моделей успешно изменен",
                        color: "success",
                    });
                    this.$router.push('/cpa-push-models/model-source-set');
                },
                catch: (err) => {
                    this.$vs.loading.close("#loader > .con-vs-loading");
                    if (err.request.status == 422 && err.data.errors) {
                        if (err.data.errors['']) {
                            const error = err.data.errors[''][0];
                            return this.$vs.notify({
                                title: 'Внимание!',
                                text: error,
                                color: 'danger'
                            });
                        } else {
                            Object.entries(err.data.errors).forEach(entry => {
                                const [key, value] = entry;
                                console.log(key, value);
                                this.errors[key] = value && value.length > 0 ? value[0] : '';
                            });
                        }
                    }

                    this.$forceUpdate();

                    return this.$vs.notify({
                        title: "Внимание!",
                        text: "Ошибка при изменении набора моделей!",
                        color: "danger",
                    });
                }
            })
        },

        onChangeModel(modelId, type) {
            let model = this.dicts.models.find(m => m.id == modelId);
            if (!model) {
                model = { modelAccType: type };
            }

            switch (model.modelAccType) {
                case CPA_ACC_TYPES.BASE: 
                    this.item.modelBaseFeatures = model.features;
                    break;
                case CPA_ACC_TYPES.BASE_CID:
                    this.item.modelBaseCidFeatures = model.features;
                    break;
                case CPA_ACC_TYPES.COMPLETE:
                    this.item.modelCompleteFeatures = model.features;
                    break;
            }
        },

        cancelEdit() {
            this.$router.push('/cpa-push-models/model-source-set');
        }
    },
    mounted() {
        this.loadData();
    },
    watch: {
    },
};
</script>

<style scoped>
.hr-line-row{
  display: flex;
  align-items: center
}
.hr-line{
  /* border-bottom: 2px solid red; */
  flex: 1;
}
.hr-span {
    margin-right: 15px;
    font-weight: bold;
}
</style>